/* Djurslottet - Om oss: karusellen langst ner.
   Servern renderar 5 bastsaljare som FALLBACK under rubriken "Kundernas favoriter".
   Har besokaren tittat pa produkter tidigare byter vi ut korten och satter rubriken
   "Fortsatt dar du slutade". Har hen inte tittat pa nagot star fallbacken kvar, sa det
   kan aldrig sta en "nyligen visade"-rubrik over produkter kunden aldrig sett.
   Vi vet inte vilken nyckel temats egen recently-viewed anvander, sa vi letar i
   localStorage efter en nyckel som innehaller "recent". */
(function () {
  var root = document.querySelector('[data-dj-car]');
  if (!root) return;
  var rail = root.querySelector('[data-dj-car-rail]');
  var head = root.querySelector('[data-dj-car-h]');

  function step(dir) {
    var card = rail.querySelector('.djom__car-card');
    if (!card) return;
    rail.scrollBy({ left: dir * (card.getBoundingClientRect().width + 14), behavior: 'smooth' });
  }
  var l = root.querySelector('.djom__car-a--l');
  var r = root.querySelector('.djom__car-a--r');
  if (l) l.addEventListener('click', function () { step(-1); });
  if (r) r.addEventListener('click', function () { step(1); });

  function arrows() {
    if (!l || !r) return;
    var max = rail.scrollWidth - rail.clientWidth - 2;
    l.style.opacity = rail.scrollLeft <= 2 ? '.3' : '1';
    r.style.opacity = rail.scrollLeft >= max ? '.3' : '1';
  }
  rail.addEventListener('scroll', arrows);
  setTimeout(arrows, 300);

  function handles() {
    var out = [];
    try {
      for (var i = 0; i < localStorage.length; i++) {
        var key = localStorage.key(i);
        if (!key || key.toLowerCase().indexOf('recent') === -1) continue;
        var raw = localStorage.getItem(key);
        if (!raw) continue;
        var val;
        try { val = JSON.parse(raw); } catch (e) { val = raw.split(','); }
        if (!Array.isArray(val)) continue;
        for (var j = 0; j < val.length; j++) {
          var v = val[j], h = null;
          if (typeof v === 'string') h = v.replace(/^.*\/products\//, '').split('?')[0];
          else if (v && typeof v === 'object') h = v.handle || (v.url ? String(v.url).replace(/^.*\/products\//, '').split('?')[0] : null);
          if (h && out.indexOf(h) === -1) out.push(h);
        }
        if (out.length) break;
      }
    } catch (e) {}
    return out.slice(0, 5);
  }

  function money(c) {
    try { return (c / 100).toLocaleString('sv-SE', { maximumFractionDigits: 0 }) + ' kr'; }
    catch (e) { return Math.round(c / 100) + ' kr'; }
  }

  function card(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    if (img) img = img.replace(/(\.(?:jpg|jpeg|png|webp|gif))(\?|$)/i, '_400x$1$2');
    var sale = p.compare_at_price && p.compare_at_price > p.price;
    var price = sale
      ? '<span class="djom__car-sale">' + money(p.price) + '</span> <s>' + money(p.compare_at_price) + '</s>'
      : money(p.price);
    return '<li class="djom__car-card"><a href="/products/' + p.handle + '">' +
      '<span class="djom__car-img">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="200" height="200">' : '') + '</span>' +
      '<span class="djom__car-t">' + (p.title || '').replace(/[<>&]/g, '') + '</span>' +
      '<span class="djom__car-p">' + price + '</span></a></li>';
  }

  var hs = handles();
  if (!hs.length) return;

  Promise.all(hs.map(function (h) {
    return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  })).then(function (list) {
    var ok = list.filter(Boolean);
    if (ok.length < 2) return;
    rail.innerHTML = ok.map(card).join('');
    if (head) head.textContent = 'Fortsätt där du slutade';
    arrows();
  });
})();
